import { Checkbox } from 'uikit';

import type React from 'react';
import { useContext } from 'react';

import { TableLikeTreeContext } from '../context';

interface IMenuColumnHeader {
    setContextMenuInHierarchyColumn?: boolean;
    disabled?: boolean;
}

export const MenuColumnHeader: React.FC<IMenuColumnHeader> = (props) => {
    const { setContextMenuInHierarchyColumn, disabled } = props;
    const context = useContext(TableLikeTreeContext);
    const { switchCheckAll, checkedIds, allItems, areCheckboxesDisabled, disabledCheckBoxesItemsIds } = context;

    return (
        <Checkbox
            style={!setContextMenuInHierarchyColumn ? { marginLeft: 12 } : { marginLeft: 24 }}
            intermediate={!!checkedIds.length && checkedIds.length !== allItems.length}
            checked={!!checkedIds.length && checkedIds.length === allItems.length}
            onChange={({ checked }) => switchCheckAll(checked)}
            disabled={disabled || areCheckboxesDisabled || !!disabledCheckBoxesItemsIds?.length}
        />
    );
};

MenuColumnHeader.displayName = 'MenuColumnHeader';
